// Figma: "CRM / Resident Detail / Email Preview Modal / Default" (18428:74342), "/ Push
// Notification Preview Modal" (18428:79644), "/ SMS Preview Modal" (18428:80604) — one
// shared shell (title, "Sent on {date} · {status}" line, 1-2 labeled fields, Done button)
// parameterized by `type`, since all three only differ in which fields they show. Opened
// from a communication row in CommunicationsPanel.js's history timeline.
import React from 'react';
import PropTypes from 'prop-types';
import {Box, Dialog, Stack, Typography} from '@mui/material';

import {tokens} from '../../../themes/ThemeCustomization';

const CommunicationPreviewModal = ({open, onClose, type, item}) => {
    if (!item) return null;

    const title = type === 'email' ? 'Email preview' : type === 'push' ? 'Push notification preview' : 'SMS preview';

    const fields =
        type === 'email'
            ? [
                  {label: 'Subject', value: item.subject},
                  {label: 'Message', value: item.body}
              ]
            : type === 'push'
              ? [
                    {label: 'Title', value: item.title},
                    {label: 'Body', value: item.body}
                ]
              : [
                    {label: 'To', value: item.to},
                    {label: 'Message', value: item.body}
                ];

    return (
        <Dialog
            open={open}
            onClose={onClose}
            PaperProps={{
                sx: {width: '540px', maxHeight: '720px', borderRadius: '12px', border: `1px solid ${tokens.color.neutral300}`}
            }}
        >
            <Box sx={{p: '20px'}}>
                <Typography sx={{fontSize: '18px', fontWeight: 600, lineHeight: '24px', color: tokens.color.neutral950}}>
                    {title}
                </Typography>
                <Typography variant="body2" sx={{color: item.statusColor || tokens.color.neutral600, pt: 0.5}}>
                    {item.sentLabel}
                    {item.statusLabel ? ` · ${item.statusLabel}` : ''}
                </Typography>
            </Box>

            <Stack sx={{px: '20px', pb: '20px'}} spacing={2}>
                {fields.map(({label, value}) => (
                    <Box key={label}>
                        <Typography variant="body2" sx={{color: tokens.color.neutral600, pb: 0.5}}>
                            {label}
                        </Typography>
                        <Typography variant="body2" sx={{color: tokens.color.neutral950, whiteSpace: 'pre-wrap'}}>
                            {value || '-'}
                        </Typography>
                    </Box>
                ))}
            </Stack>

            <Stack
                direction="row"
                justifyContent="flex-end"
                sx={{p: 1.5, backgroundColor: tokens.color.neutral50, borderTop: `1px solid ${tokens.color.neutral200}`}}
            >
                <Box
                    component="button"
                    onClick={onClose}
                    sx={{
                        height: 32,
                        px: 1.5,
                        border: `1px solid ${tokens.color.neutral200}`,
                        borderRadius: tokens.radius.control,
                        backgroundColor: tokens.color.white,
                        cursor: 'pointer',
                        fontSize: '14px',
                        fontWeight: 500,
                        color: tokens.color.neutral950
                    }}
                >
                    Done
                </Box>
            </Stack>
        </Dialog>
    );
};

CommunicationPreviewModal.propTypes = {
    open: PropTypes.bool.isRequired,
    onClose: PropTypes.func.isRequired,
    type: PropTypes.oneOf(['email', 'push', 'sms']),
    item: PropTypes.object
};

export default CommunicationPreviewModal;
